export default {
	lang: 'tw',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav0": '帳號安全',
		 "nav1": '我的雲盤',
		 "nav2": '登出登入',
		 "nav3": '登入/註冊',
		 "nav4": '可錄製手機上的通話以及音訊內容，並轉換成文字。需連接 VTransBUDS 系列耳機進行使用。 ',
		 "nav5": '掃碼下載',
		 "nav6": '重要溝通，高效率回溯',
		 "speaker_not_null": '不能編輯講話人為空!',
		 "speaker": '講話人',
		 "copy_success": '複製成功',
	},
	login: {
		"login1": '密碼登入',
		 "login2": '簡訊登入',
		 "loginTab3": '郵箱登入',
		 "login3": '郵箱',
		 "login4": '登入密碼',
		 "login5": '手機號碼',
		 "login6": '請選擇',
		 "login7": '手機驗證碼',
		 "login8": '登入',
		 "login9": '忘記密碼',
		 "login10": '註冊',
		 "login11": '登入即表示您同意',
		 "login12": '服務協定',
		 "login13": '隱私協定',
		 "login14": '獲取',
		 "login15": '中國',
		 "login16": '請輸入帳號',
		 "login17": '請輸入密碼',
		 "login18": '登入成功!',
		 "login19": '請輸入驗證碼!',
		 "login20": '發送成功!',
		 "login21": '和',
		 "login22": '錄音筆雲盤',
		 "login23": '我的寫作',
		 "login24": '我的對話',
		 "login25": '帳號安全',
		 "login26": '登出登入',
		 "login27": '信箱找回密碼',
		 "login28": '郵箱',
		 "login29": '信箱驗證碼',
		 "login30": '設定登入密碼（6-16位元字元）',
		 "login31": '再次輸入登入密碼',
		 "login32": '提交',
		 "login33": '返回登入',
		 "login34": '修改成功!',
	},
	register: {
		"register1": '手機號碼',
		 "register2": '請輸入您的手機',
		 "register3": '請選擇',
		 "register4": '手機驗證碼',
		 "register5": '設定密碼',
		 "register6": '請輸入驗證碼',
		 "register7": '6-16位元字元',
		 "register8": '密碼確認',
		 "register9": '郵箱',
		 "register10": '請輸入信箱',
		 "register11": '信箱驗證碼',
		 "register12": '請輸入驗證碼',
		 "register13": '我已閱讀並同意',
		 "register14": '請閱讀並勾選同意協議',
		 "register15": '手機號碼格式錯誤 / 手機號碼已註冊',
		 "register16": '手機驗證碼錯誤',
		 "register17": '請輸入信箱 / 信箱格式錯誤',
		 "register18": '信箱格式錯誤',
		 "register19": '郵箱驗證碼錯誤',
		 "register20": '密碼請設定6-16位元字元',
		 "register21": '密碼格式錯誤',
		 "register22": '兩次輸入的密碼不一致，請重新輸入',
		 "register23": '請輸入密碼',
		 "register24": '註冊成功!',
		 "register25": '驗證碼錯誤',
	},
	recorder: {
		"recorder1": '我的雲端磁碟',
		 "recorder2": '雲端空間容量',
		 "recorder3": '最近文件',
		 "recorder331":'回收站',
		 "recorder332":'全部刪除',
		 "recorder4": '名稱',
		 "recorder5": '音訊時長',
		 "recorder6": '檔案大小',
		 "recorder7": '建立時間',
		 "recorder8": '操作',
		 "recorder9": '雲端空間說明',
		 "recorder10": '音訊',
		 "recorder11": 'OCR檔',
		 "recorder12": '1.雲端空間是用來做什麼的?',
		 "recorder13": '在錄音筆上錄音完成後，您可以上傳音訊和轉寫檔案至雲端空間，即使錄音筆不在身邊，您也可以進入雲空間查看音訊。 ',
		 "recorder14": '2.如何上傳雲端空間?',
		 "recorder15": '在錄音筆上進入【我的檔案】，選中目標檔案長按出現選項，點擊“上傳”，即可將檔案上傳至雲端空間。 ',
		 "recorder16": '3.如何檢視/管理雲端空間檔案?',
		 "recorder17": '登入貝鉑官網，選擇“我的-錄音筆雲盤”，就可以查看已經上傳的錄音筆檔案。您可以選擇目標檔案進行下載、刪除等操作。您可以透過刪除雲空間檔案來清理雲端空間的儲存哦!',
		 "recorder18": '未轉寫',
		 "recorder19": '查看摘要',
		 "recorder20": '講話人',
		 "recorder21": '編輯講話人名稱',
		 "recorder22": '確定',
		 "recorder23": '下載',
		 "recorder24": '下載內容：',
		 "recorder25": '下載設定：',
		 "recorder26": '顯示說話者',
		 "recorder27": '取消',
		 "recorder28": '連結分享',
		 "recorder29": '獲得連結的人都可以訪問，僅支持閱讀，連結7天有效',
		 "recorder30": '複製連結',
		 "recorder31": '掃一掃，快速檢視',
		 "recorder32": '智慧整理',
		 "recorder33": '區別說話者',
		 "recorder34": '依照講話人角色，智能區分轉寫文字',
		 "recorder35": '智慧口說規則',
		 "recorder36": '自動過濾語氣詞、重複詞、停頓詞',
		 "recorder37": '非人聲過濾',
		 "recorder38": '播放時自動跳過無人聲，噪音的音訊',
		 "recorder39": '請選擇',
		 "recorder40": '文檔',
		 "recorder41": '音訊',
		 "recorder42": '文檔+音訊',
		 "recorder43":'提示',
		 "recorder44":'此操作將刪除該檔案, 是否繼續?',
		 "recorder441":'此操作將刪除全部檔案, 是否繼續?',
		 "recorder45":'確定',
		 "recorder46":'取消',
		 "recorder47":'刪除成功!',
		 "recorder48":'已取消刪除',
		 "recorder49":'暫無標記',
		 "recorder50":"正在儲存…",
		 "recorder51":'回收站',
	},
	personal: {
		"personal1": '帳號設定',
		 "personal2": '個人資料',
		 "personal3": '頭像',
		 "personal4": '上傳檔案',
		 "personal5": '支援JPG、JPEG、GIF、PNG 風格，支援 2M 以內的圖片',
		 "personal6": '暱稱',
		 "personal7": '請輸入暱稱',
		 "personal8": '性別',
		 "personal9": '先生',
		 "personal10": '女士',
		 "personal11": '保密',
		 "personal12": '生日',
		 "personal13": '請選生日',
		 "personal14": '職業',
		 "personal15": '請選擇職業',
		 "personal16": '請輸入職業（非必填）',
		 "personal17": '國家',
		 "personal18": '請選擇國家',
		 "personal19": '保存',
		 "personal20": '個人資料',
		 "personal21": '帳戶安全',
		 "personal22": '只支援2M以內的圖片',
		 "personal23": '上傳成功!',
		 "personal24": '修改成功!',
		 "personal25": '帳戶安全',
		 "personal26": '登入密碼',
		 "personal27": '修改',
		 "personal28": '電子郵件',
		 "personal29": '更換',
		 "personal30": '帳號註銷',
		 "personal32": '確定註銷帳戶嗎？ ',
		 "personal33": '登出後，您在帳戶下的全部內容將全部清除，請謹慎操作。 ',
		 "personal34": '取消',
		 "personal35": '確定',
		 "personal36": '身份驗證',
		 "personal37": '為確認是您本人操作，請透過信箱驗證碼完成身份驗證',
		 "personal38": '信箱',
		 "personal39": '驗證碼',
		 "personal40": '請輸入驗證碼',
		 "personal41": '下一步',
		 "personal42": '設定新信箱',
		 "personal43": '郵箱',
		 "personal44": '請輸入新信箱',
		 "personal45": '驗證碼',
		 "personal46": '請輸入驗證碼',
		 "personal47": '確定',
		 "personal48": '設定新登入密碼',
		 "personal49": '新登入密碼',
		 "personal50": '請輸入新密碼',
		 "personal51": '確認新密碼',
		 "personal52": '請再輸入新密碼',
		 "personal53": '確定',
		 "personal54": '獲取',		
		 "personal55": '信箱格式錯誤',
		 "personal56": '更換成功!',
		 "personal57": '密碼請設定6-16位元字元',
		 "personal58": '兩次輸入的密碼不一致',
		 "personal59": '修改成功!',
		 "personal60": '登出成功!',
		 "share_url": "連結分享",
		  "share_url_7_day": "分享連結有效期為7天。失效前，任何獲得連結的人都可以存取。",
		  "share_audio": "錄音音訊",
		  "share_trans_text": "轉寫內容",
		  "share_summny_text": "總結內容",
		  "share_map": "心智圖",
		  "share_url_pw": "存取加密",
		  "share_random_pw": "密碼隨機產生",
		  "share_url_copy": "複製連結",
		  "share_link_pw": "存取密碼",
		  "share_copy_success": "複製成功!",
		  "share_speaker": "說話者",
		  "share_no_update_speaker": "無法編輯講話人為空",
		  "share_no_trans":"無轉寫文字",
		  "share_no_summny":"無摘要文字",
		  "share_no_map":"無導圖內容",
		  "share_trans_text_1": "轉寫",
		  "share_summny_text_1": "總結",
		  "share_map_1": "導圖",
		  "share_save": "儲存成功",
		  "share_no_map":"導圖圖片未產生",
		  "share_update_text": "編輯轉寫文本",
		"share_update_text2": "編輯總結文本",
		"showLoading": "載入中...",
	}
}